import styled from 'styled-components';

export const DivMain = styled.div`
    display:flex;
    flex-direction:column;
    height:inherit;
    justify-content:start;
    align-items:center;
    background-color:#fff;
    padding:20px 0 0 0;
`;
export const Button = styled.button`
    margin:20px 0 0 0;
    border:1px solid #333333;
    background-color:#333333;
    border-radius:5px;
    padding:5px;
    cursor:pointer;
    width: 300px;
    height:40px;
    display: flex;
    justify-content: center;
    align-items: center;
    color:#fff;
    font-size:16px;
    font-family:'Ubuntu', sans-serif;
    :active {
        box-shadow: inset 0 0 2px rgba(128, 128, 128, 0.1);
        transform: translateY(2px);
    }

    @media(max-width:800px){
        width:auto;
        height:40px;
    }

`
